/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Changelogdescription1Inputs */

const id_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan yang diamati di seluruh penawaran, item, asset, build, dan metadata katalog terkait sandbox ini.`)
};

const ms_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan yang diperhatikan di seluruh tawaran, item, aset, binaan, dan metadata katalog berkaitan sandbox ini.`)
};

const da_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observerede ændringer på tværs af denne sandbox's tilbud, items, assets, builds og relateret katalogmetadata.`)
};

const de_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beobachtete Änderungen in den Angeboten, Items, Assets, Builds und zugehörigen Katalogmetadaten dieser Sandbox.`)
};

const en_us2_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed changes across this sandbox's offers, items, assets, builds, and related catalog metadata.`)
};

const es_es2_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios observados en las ofertas de catálogo, ítems, assets, compilaciones y metadatos relacionados de este sandbox.`)
};

const es_mx2_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios observados en las ofertas, ítems, assets, compilaciones y metadatos relacionados de este sandbox.`)
};

const fil_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naobserbahang pagbabago sa mga offer, item, asset, build, at kaugnay na metadata ng catalog ng sandbox na ito.`)
};

const fr_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications observées dans les offres, items, assets, compilations et métadonnées associées de ce sandbox.`)
};

const it_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche osservate tra offerte, articoli, asset, build e metadati di catalogo correlati di questo sandbox.`)
};

const hu_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megfigyelt változások a sandbox ajánlatai, elemei, asset-jei, build-jei és kapcsolódó katalógus metaadatai között.`)
};

const nl_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waargenomen wijzigingen in de aanbiedingen, items, assets, builds en gerelateerde catalogusmetadata van deze sandbox.`)
};

const no_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observerte endringer på tvers av denne sandboxens tilbud, elementer, eiendeler, builds og relatert katalogmetadata.`)
};

const pl_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaobserwowane zmiany w ofertach, elementach, assetach, kompilacjach i powiązanych metadanych katalogu tego sandboxa.`)
};

const pt_br2_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações observadas nas ofertas de catálogo, itens, assets, builds e metadados relacionados deste sandbox.`)
};

const pt_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações observadas nas ofertas, itens, assets, compilações e metadados de catálogo relacionados desta sandbox.`)
};

const ro_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări observate în ofertele, elementele, asset-urile, compilările și metadatele de catalog conexe ale acestui sandbox.`)
};

const fi_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havaitut muutokset tämän hiekkalaatikon tarjouksissa, kohteissa, resursseissa, koontiversioissa ja niihin liittyvissä katalogin metatiedoissa.`)
};

const sv_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observerade ändringar i denna sandlådas erbjudanden, objekt, tillgångar, byggen och relaterad katalogmetadata.`)
};

const vi_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các thay đổi được quan sát trên các ưu đãi, mục, asset, bản dựng và siêu dữ liệu danh mục liên quan của sandbox này.`)
};

const tr_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sandbox'ın teklifleri, öğeleri, assetleri, yapıları ve ilgili katalog meta verilerinde gözlemlenen değişiklikler.`)
};

const cs_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledované změny napříč nabídkami, položkami, assety, sestaveními a souvisejícími katalogovými metadaty tohoto sandboxu.`)
};

const bg_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наблюдавани промени в офертите, обектите, активите, компилациите и свързаните каталог метаданни на този sandbox.`)
};

const ru_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наблюдаемые изменения в предложениях, объектах, ассетах, сборках и связанных метаданных каталога этой песочницы.`)
};

const uk_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спостережувані зміни пропозицій, елементів, асетів, збірок та пов'язаних метаданих у цьому Sandbox.`)
};

const ar_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات المرصودة عبر عروض وعناصر وأصول وبُنيات وبيانات تعريف الكتالوج ذات الصلة في Sandbox هذا.`)
};

const hi_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सैंडबॉक्स के ऑफ़र, आइटम, एसेट, बिल्ड और संबंधित कैटलॉग मेटाडेटा में देखे गए परिवर्तन।`)
};

const th_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงที่สังเกตได้ในข้อเสนอ รายการ แอสเซท บิลด์ และเมทาดาทาแค็ตตาล็อกที่เกี่ยวข้องในแซนด์บ็อกซ์นี้`)
};

const ja_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサンドボックスのオファー、アイテム、アセット、ビルド、関連カタログメタデータ全体で観察された変更。`)
};

const zh_cn2_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`观察到的此沙盒目录项、物品、资源、构建版本及相关元数据的变更。`)
};

const zh_hant1_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀察到的此沙盒目錄項目、物品、資源、建置版本及相關中繼資料的變更。`)
};

const ko_sandboxes_changelogdescription1 = /** @type {(inputs: Sandboxes_Changelogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Sandbox의 오퍼, 아이템, 에셋, 빌드 및 관련 카탈로그 메타데이터에 대한 관찰된 변경 사항입니다.`)
};

/**
* | output |
* | --- |
* | "Observed changes across this sandbox's offers, items, assets, builds, and related catalog metadata." |
*
* @param {Sandboxes_Changelogdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_changelogdescription1 = /** @type {((inputs?: Sandboxes_Changelogdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Changelogdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_changelogdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_changelogdescription1(inputs)
	if (locale === "da") return da_sandboxes_changelogdescription1(inputs)
	if (locale === "de") return de_sandboxes_changelogdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_changelogdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_changelogdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_changelogdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_changelogdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_changelogdescription1(inputs)
	if (locale === "it") return it_sandboxes_changelogdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_changelogdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_changelogdescription1(inputs)
	if (locale === "no") return no_sandboxes_changelogdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_changelogdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_changelogdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_changelogdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_changelogdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_changelogdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_changelogdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_changelogdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_changelogdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_changelogdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_changelogdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_changelogdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_changelogdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_changelogdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_changelogdescription1(inputs)
	if (locale === "th") return th_sandboxes_changelogdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_changelogdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_changelogdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_changelogdescription1(inputs)
	return ko_sandboxes_changelogdescription1(inputs)
});
export { sandboxes_changelogdescription1 as "sandboxes.changelogDescription" }